import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useSessionContext from '../../../data/queryHooks/useSessionContext';

const LinkBehavior = forwardRef((props, ref) => (
	<RouterLink ref={ref} to='/switchLocation' {...props} />
));

LinkBehavior.displayName = 'LinkBehavior';

const UserInfo = ({ hasDefaultLocation }) => {
	const { palette } = useTheme();

	const { userInfo } = useSessionContext();
	const {
		lastName = '',
		firstName = '',
		address1 = '',
		city = '',
		state = '',
		zipCode = '',
	} = userInfo;

	return (
		<Stack
			spacing={2}
			divider={
				<Box
					display='flex'
					sx={{
						borderRight: '1px solid',
						backgroundColor: palette.text.light,
					}}
				/>
			}
			color={palette.text.primary}
			direction='row'
			justifyContent='flex-end'
		>
			<Typography variant='subtitle2'>
				{`${firstName} ${lastName}`}
			</Typography>
			<Typography variant='subtitle2'>
				{`${address1} - ${city}, ${state} ${zipCode}`}
			</Typography>
			<Typography variant='subtitle2'>Fitness</Typography>
			{hasDefaultLocation && (
				<Link
					component={LinkBehavior}
					variant='subtitle2'
					sx={{ zIndex: 9 }}
				>
					Switch Location
				</Link>
			)}
		</Stack>
	);
};

UserInfo.propTypes = {
	hasDefaultLocation: PropTypes.bool.isRequired,
};

export default UserInfo;
